import { getRankIcon } from "../helpers/uiHelpers";

export default function LeaderboardAccordion({ isStatsLoading, topUsersList }) {
  return (
    <div className="accordion-body bg-light">
      {isStatsLoading ? (
        <div className="text-center py-3 text-muted">Menghitung ranking...</div>
      ) : (
        <div className="d-flex flex-column gap-2">
          {/* Header kecil */}
          <div className="d-flex px-3 text-muted small fw-bold mb-1">
            <div style={{ width: "50px" }} className="text-center">
              Rank
            </div>
            <div className="flex-grow-1">User</div>
            <div>Total Login</div>
          </div>

          {/* Looping Data Leaderboard */}
          {topUsersList.map((user, index) => {
            let rankClass =
              index === 0
                ? "rank-1"
                : index === 1
                ? "rank-2"
                : index === 2
                ? "rank-3"
                : "bg-white border-start";

            return (
              <div
                key={user.name + index}
                className={`d-flex align-items-center p-2 rounded leaderboard-item ${rankClass}`}
                style={{
                  animation: `smoothSlideIn 0.4s ease-out ${
                    index * 0.08
                  }s both`,
                }}
              >
                <div style={{ width: "50px" }} className="text-center me-2">
                  {getRankIcon(user.rank)}
                </div>
                <div className="flex-grow-1">
                  <h6
                    className={`m-0 fw-bold ${
                      index < 3 ? "text-dark" : "text-secondary"
                    }`}
                  >
                    {user.name}
                  </h6>
                </div>
                <div>
                  <span
                    className={`badge rounded-pill font-monospace fs-6 ${
                      index < 3 ? "bg-primary" : "bg-light text-dark border"
                    }`}
                  >
                    {user.count}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
